<div id="myModaldeleteNew" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
        <h4 class="screenhead">SCREEN RESOLUTION SETTINGS FOR DOWNLOAD REPORT</h4>
        <div class="screencontent">
            <p>Your screen resolution is {{screenwidth}} x {{screenheight}}</p>
            <p>This report is optimized to generate on 1366 x 768 screen resolution</p>
            <p>Temporarily change your screen resolution to 1366 x 768 to be able to download the report </p>
            <p>(Right click on desktop>>Display Settings>>Screen Resolution)</p>
            <p>Please revert back to your original settings, once the report is generated</p>
            <!-- <button id="dwdproj" >Yes</button> -->
            <button id="canclprojNew">OK</button>
        </div>
    </div>

</div>

<div id="brushdiv">Loading....</div>
<div id="expm">
    <div id="pdfdoc">
        <div class="row">
            <div class="col-md-6">

                <!-- <img src="assets/images/ecom.PNG"/> -->
            </div>
            <div class="col-md-6">
                <!-- <img class="float-right" id="adslg" src="assets/images/logo1.png"/> -->
            </div>
        </div>

        <div class="row martopFirst">
            <div class="col-md-6" *ngFor="let build of modval?.usrLists">

                <h2>{{build.build_project}} AT {{ build.city }} , {{ build.country }}</h2>
                <h4>Building Energy and cost optimization study</h4>
                <h4>{{crtDate | date :'longDate' }}</h4>

            </div>

            <div class="col-md-6">
                <img class="float-right" src="assets/images/logo1.png" />
            </div>

        </div>

        <div class="row marbottomSec">
            <div class="col-md-12 mt-3">
                <img class="snkpng img-responsive" src="assets/images/sankeynew.png" />

            </div>

        </div>
        <div class="row">
            <div class="staticb">1.1 BUILDING MODEL SETUP INFORMATION</div>
        </div>
        <div class="row marbottomThi">
            <div class="col-md-6">

                <table *ngFor="let build of modval?.usrLists">
                    <tr>
                        <th colspan="2">SITE AND LOCATION </th>


                    </tr>
                    <tr>
                        <td>BUILDING DETAILS</td>
                        <td>{{build.build_project}}</td>

                    </tr>
                    <tr>
                        <td>LOCAION</td>
                        <td>{{build.city}},{{build.country}}</td>

                    </tr>

                </table>

                <table *ngFor="let build of modval?.usrLists">
                    <tr>
                        <th colspan="2">OCCUPANCY TYPE</th>
                        <td>{{build.occupancy}}</td>

                    </tr>
                    <!-- <tr>
                                   <td>RESIDENTIAL HOTEL</td>
                                   <td>{{build.occupancy}}</td>
                                   
                                  
                                 </tr> -->


                </table>

                <table *ngFor="let build of modval?.usrLists">
                    <tr>
                        <th colspan="3">CONDITIONING SETPOINTS</th>


                    </tr>
                    <tr>
                        <td>COOLING SETPOINT</td>
                        <td>{{build.cooling_sp}}</td>
                        <td>C</td>

                    </tr>

                    <tr>
                        <td>HEATING SETPOINT</td>
                        <td>{{build.heating_sp}}</td>
                        <td>C</td>

                    </tr>


                </table>

                <table *ngFor="let build of modval?.usrLists">

                    <tr>
                        <td>INFILTRATION</td>
                        <td>{{build.infiltration}}</td>
                        <td>l/s/m2 (façade + roof)</td>
                        <!-- <td>CFM/SFT (FAC)</td> -->

                    </tr>

                </table>


                <table *ngFor="let build of modval?.usrLists">
                    <tr>
                        <th colspan="3">BUILDING AREA STATEMENT</th>


                    </tr>
                    <tr>
                        <td>WALLS</td>
                        <td>{{build.wall}}</td>
                        <td>SQM</td>

                    </tr>

                    <tr>
                        <td>ROOF</td>
                        <td>{{build.roof}}</td>
                        <td>SQM</td>

                    </tr>
                    <tr>
                        <td>WINDOWS</td>
                        <td>{{build.wall * wwronerep | number:'1.1-2'}}</td>
                        <td>SQM</td>

                    </tr>
                    <tr>
                        <td>GROUND FLOOR</td>
                        <td> {{build.ground_flr}}</td>
                        <td>SQM</td>

                    </tr>
                    <tr>
                        <td>ALL FLOOR</td>
                        <td>{{build.all_flrs}}</td>
                        <td>SQM</td>

                    </tr>


                </table>


                <table *ngFor="let build of modval?.usrLists">
                    <tr>
                        <th colspan="2">WEATHER DATA INFORMATION</th>
                    </tr>
                    <tr>
                        <td>HDD</td>
                        <td>{{build.heating_degree_day}}</td>
                    </tr>

                    <tr>
                        <td>CDD</td>
                        <td>{{build.cooling_degree_day}}</td>
                    </tr>
                    <tr>
                        <td>ASHRAE CLIMATE ZONE</td>
                        <td>{{build.ashrae_climate_zone}}</td>
                    </tr>
                    <tr>
                        <td>NECB CLIMATE ZONE</td>
                        <td>{{build.necb_climate_zone}}</td>
                    </tr>



                </table>




            </div>
            <div class="col-md-6">
                <!-- <img class="float-right img-responsive" id="adslg" src="assets/images/3dmodel.PNG"/> -->
                <!-- <div  [innerHTML]="ebmbededCode?.embed_url | safeHtml"> -->
                <!-- <img width="440" height="380" src="https://sketchfab.com/models/72a7c6f16a72448a8145ad9c01abf0be/embed"> -->
            </div>
        </div>

        <div class="row">
            <div class="staticb">1.2 SPECTRUM OF DESIGN OPTIONS</div>
        </div>


    </div> <!-- end of pdfdoc -->

    <app-loader id="mater"></app-loader>


    <div id="example" class="parcoords" #content></div>
    <!-- <div id="threebtn">
   <button id="backwiz" (click)="backClicked()" class="backMfrd" mat-raised-button color="primary">Wizard Variables</button>
   
   <button id="dwdpdf" (click) = "downloadPdf()"  type="button" mat-raised-button color="primary">Download Report</button>
   <button id="actcost" (click) = "activateCost()"  type="button" mat-raised-button color="primary">Activate Cost Analysis</button>
 </div> -->
    <div id="gridOuter" class="mt-4">
        <!-- <span id="dl">SEN</span>
   <span id="hvacsys">SYS</span>
   <span id="heatrec">REC.</span>
   <span id="eui">kWh/m2/yr</span>
   <span id="savings">%</span> -->
        <span id="savingscost"></span>
        <div id="grid" class="mygrid"></div>

    </div>
    <div id="upval">
        <h3>Below graph values are not updated on chart selection, please click on grid options to get
            updated values on graph</h3>
    </div>
    <!-- hidetwo div start -->

    <div id="hidetwo">
        <div class="row marbottomRep justify-content-center mt-4">
            <div class="col-md-3">
                <table>
                    <tr>
                        <th class="text-center">SELECTED OPTION</th>
                    </tr>
                    <tr>
                        <td class="text-center">{{cellOption}}</td>
                    </tr>

                </table>
            </div>
            <div class="col-md-3">
                <table>
                    <tr>
                        <th class="text-center">% ENERGY SAVINGS</th>
                    </tr>
                    <tr>
                        <td class="text-center">{{savingsrep}} %</td>
                    </tr>

                </table>
            </div>

            <div class="col-md-3">
                <table>
                    <tr>
                        <th class="text-center">EUI (KWh/m2/yr)</th>
                    </tr>
                    <tr>
                        <td class="text-center">{{euirepnew}} </td>
                    </tr>

                </table>
            </div>

            <div class="col-md-3">
                <table>
                    <tr>
                        <th class="text-center">COST PREMIUM (SURCHARGE) CAD($)</th>
                    </tr>
                    <tr>
                        <td class="text-center">{{costNew}} </td>
                    </tr>

                </table>
            </div>
        </div>
        <div class="row martopNewEng" id="loadsum">
            <!-- <div id="stack_chart_report" class= "mychart" style="width:500px;height:400px"></div> -->
            <div class="staticb">1.3 ENERGY SUMMARY COMPARISON </div>

        </div>

        <div class="row">

            <!--  Energy summary  START -->
            <table id="summarystart">
                <tr>
                    <td colspan="2"> ENERGY SUMMARY</td>
                    <td colspan="9"></td>



                </tr>
                <tr>
                    <td></td>
                    <td>HEATING</td>
                    <td>COOLING</td>
                    <td>FANS</td>
                    <td>PUMPS </td>
                    <td>HEAT REJ </td>
                    <td>DHW </td>
                    <td>LIGHT </td>
                    <td>EQUIP </td>
                    <td>RENEWABLE </td>
                    <td>Total(MWh) </td>
                </tr>

                <tr>
                    <td>{{cellOption}}</td>
                    <td>{{HeatingEnergyData}} </td>
                    <td>{{CoolingEnergyData}}</td>
                    <td>{{FansEnergyData}}</td>
                    <td>{{PumpsEnergyData}}</td>
                    <td>{{HeatRejEnergyData}}</td>
                    <td>{{DHWEnergyData}} </td>
                    <td>{{LightingEnergyData}} </td>
                    <td>{{equipEnergyData}}</td>
                    <td>{{RenewEnergyData}}</td>

                    <td>{{ HeatingEnergyData + CoolingEnergyData + FansEnergyData + PumpsEnergyData + HeatRejEnergyData
                        + LightingEnergyData + equipEnergyData + RenewEnergyData + DHWEnergyData | number:'1.1-2' }}
                    </td>
                </tr>

                <tr>
                    <td *ngIf='newAshNecb !== "noash"'>{{newAshNecbNew | uppercase}}</td>
                    <td *ngIf='newAshNecb == "noash"'>Custom Baseline</td>
                    <td>{{Heating }} </td>
                    <td>{{Cooling }}</td>
                    <td>{{Fans}} </td>
                    <td>{{Pumps}} </td>
                    <td>{{HeatRej}}</td>
                    <td>{{DHW}}</td>
                    <td>{{Lighting}} </td>
                    <td>{{equipBaseline}}</td>
                    <td *ngIf='newAshNecb !== "noash"'>0</td>
                    <td *ngIf='newAshNecb == "noash"'>{{RenewBaseline}}</td>
                    <td *ngIf='newAshNecb !== "noash"'>{{baselineTotal | number:'1.1-2' }}</td>
                    <td *ngIf='newAshNecb == "noash"'>{{baselineTotal + RenewBaseline | number:'1.1-2' }}</td>
                </tr>

                <tr>
                    <td colspan="8"></td>
                    <td colspan="2">% Energy Saving </td>
                    <td>{{savingsrep}} % </td>

                </tr>






            </table>



            <!-- Energy summary  END -->

            <!-- <div id="stack_chart_report" class= "mychart" style="width:500px;height:400px"></div> -->

        </div>

        <div class="row marbottom">

            <div id="stack_chart_report" class="mychart stack_chart_report-class"></div>

        </div>

        <!-- COSTSURCHARGE START -->

        <div class="row martopNew">
            <!-- <div id="stack_chart_report" class= "mychart" style="width:500px;height:400px"></div> -->
            <div class="staticb">1.4 LOADS SUMMARY COMPARISON </div>

        </div>

        <div class="row">

            <!--  <div class="col-md-6">
      
           <div id="stack_chart_report" class= "mychart" style="width:500px;height:400px"></div>
 
       </div> -->


            <div class="col-md-6 marbottomLoadsFirst">
                <!-- <div id="group_chart_Rep" class= "mychart" style="width:500px;height:300px"></div> -->
                <table>
                    <tr>
                        <td colspan="3"> LOADS SUMMARY</td>




                    </tr>
                    <tr>
                        <td></td>
                        <td>HEATING (kW)</td>
                        <td>COOLING (TR)</td>

                    </tr>

                    <tr>
                        <td>{{cellOption}}</td>
                        <td>{{ heatLoadDesign}} </td>
                        <td>{{ coolLoadDesign }}</td>

                    </tr>

                    <tr>
                        <td *ngIf='newAshNecb !== "noash"'>{{newAshNecbNew | uppercase}}</td>
                        <td *ngIf='newAshNecb == "noash"'>Custom Baseline</td>
                        <td>{{ heatLoadBaseline}} </td>
                        <td>{{ coolLoadBaseline }}</td>

                    </tr>








                </table>


                <div id="group_chart_Rep" class="mychart group-chart-class"></div>

            </div>

        </div>

        <div class="row martopNewFirst">
            <!-- <div id="stack_chart_new_rep" class= "mychart" style="width:600px;height:400px;margin-left:100px"></div> -->
            <div class="staticb">1.5 COST SURCHARGE CALCULATIONS </div>

        </div>


        <div class="row marbottomLoadsFour">

            <!--  Energy summary  START -->
            <table id="summarystartCost">
                <tr>
                    <td colspan="2"> ENERGY SUMMARY</td>
                    <td colspan="9"></td>



                </tr>
                <tr>
                    <td></td>
                    <td>WALL</td>
                    <td>ROOF</td>
                    <td>G. FLOOR</td>
                    <td>WINDOW</td>
                    <td>SHADING </td>
                    <td>LIGHTING </td>
                    <td>DL SENSORS </td>
                    <td>HVAC </td>
                    <td>HEAT REC </td>
                    <td>SOLAR PV </td>
                    <td>WIND TURB </td>
                    <td>TOTAL ($) </td>
                </tr>

                <tr>
                    <td>{{cellOption}}</td>
                    <td>{{wall_costopt}} </td>
                    <td>{{roof_costopt}}</td>
                    <td>{{flr_costopt}}</td>
                    <td>{{win_costopt}}</td>
                    <td>{{shading_costopt}}</td>
                    <td>{{lpd_costopt}} </td>
                    <td>{{daylight_sensor_costopt}} </td>
                    <td>{{hvacCostopt}}</td>
                    <td>{{heatRecoveryCostopt}}</td>
                    <td>{{solarCostopt}} </td>
                    <td>{{windCostopt}} </td>
                    <td>{{ wall_costopt + roof_costopt + flr_costopt + win_costopt + shading_costopt + lpd_costopt +
                        daylight_sensor_costopt + hvacCostopt + heatRecoveryCostopt + windCostopt + solarCostopt |
                        number:'1.1-2' }}</td>
                    <!-- <td>{{windCostopt}} </td> -->
                    <!-- <td>TOTAL </td> -->
                </tr>

                <tr>
                    <td *ngIf='newAshNecb !== "noash"'>{{newAshNecbNew | uppercase}}</td>
                    <td *ngIf='newAshNecb == "noash"'>Custom Baseline</td>
                    <td>{{wall_cost}} </td>
                    <td>{{roof_cost }}</td>
                    <td>{{flr_cost}} </td>
                    <td>{{win_cost}} </td>
                    <td>{{shading_cost}}</td>
                    <td>{{lpd_cost}}</td>
                    <td>{{daylight_sensor_cost}} </td>
                    <td>{{hvacCost}}</td>
                    <td *ngIf='newAshNecb !== "noash"'>{{heatRecoveryCost}}</td>
                    <td *ngIf='newAshNecb == "noash"'>{{heatRecoveryCostLum}}</td>

                    <td *ngIf='newAshNecb !== "noash"'>0</td>
                    <td *ngIf='newAshNecb !== "noash"'>0 </td>
                    <td *ngIf='newAshNecb == "noash"'>{{solarCostopt}}</td>
                    <td *ngIf='newAshNecb == "noash"'>{{windCostopt}}</td>
                    <td *ngIf='newAshNecb !== "noash"'>{{ wall_cost + roof_cost + flr_cost + win_cost + shading_cost +
                        lpd_cost + daylight_sensor_cost + hvacCost + heatRecoveryCost | number:'1.1-2' }} </td>
                    <td *ngIf='newAshNecb == "noash"'>{{ wall_cost + roof_cost + flr_cost + win_cost + shading_cost +
                        lpd_cost + daylight_sensor_cost + hvacCost + heatRecoveryCostLum + solarCostopt + windCostopt |
                        number:'1.1-2' }} </td>
                </tr>

                <tr>
                    <td colspan="10"></td>
                    <td colspan="2">COST PREMIUM (SURCHARGE) </td>
                    <td>
                        <!--   wall_costopt + roof_costopt + flr_costopt + win_costopt + shading_costopt + lpd_costopt + daylight_sensor_costopt + hvacCostopt + heatRecoveryCostopt + windCostopt + solarCostopt +
               wall_cost + roof_cost + flr_cost + win_cost + shading_cost + lpd_cost + daylight_sensor_cost + hvacCost + heatRecoveryCost | number:'1.1-2' -->

                        {{ costNew}}
                    </td>

                </tr>






            </table>



            <!-- Energy summary  END -->
            <div id="stack_chart_new_rep" class="mychart stack_chart_new_rep-class"></div>

        </div>


        <!-- COSYSURCHARGE END -->

        <!-- <div class="row">
      
 
        <div class="col-md-6">
         <div id="group_chart_Rep" class= "mychart" style="width:500px;height:300px"></div>
             <table>
                     <tr>
                         <td colspan="3"> LOADS SUMMARY</td>
                        
                         
                         
                         
                       </tr>
                       <tr>
                         <td></td> 
                         <td>HEATING (kW)</td> 
                         <td>COOLING (TR)</td>
                         
                       </tr>
             
                       <tr>
                         <td>{{cellOption}}</td>
                         <td>{{ heatLoadDesign}} </td> 
                         <td>{{ coolLoadDesign }}</td>
                         
                       </tr>
             
                       <tr>
                         <td *ngIf ='newAshNecb !== "noash"'>{{newAshNecb}}</td>
                         <td *ngIf ='newAshNecb == "noash"'>Custom Baseline</td> 
                         <td>{{ heatLoadBaseline}} </td> 
                         <td>{{ coolLoadBaseline }}</td>
                         
                       </tr>
             
                      
             
                       
             
                      
             
             
                     </table>
 
 
                   
 
        </div>
 
   </div> -->

        <div class="row">
            <div class="col-md-12">


            </div>
        </div>


        <div class="row">
            <div class="staticb">A1.1 SIMULATION ASSUMPTIONS COMPARISON </div>


        </div>

        <div class="row marbottomLoadsThree">
            <!-- BUILDING PERFORMANCE VARIABLES  START -->
            <table id="buildper" *ngFor="let folder of buildEnv?.projLists  | slice:0:1">

                <tr>
                    <th>BUILDING PERFORMANCE VARIABLES</th>
                    <th>{{cellOption}}</th>
                    <th *ngIf='newAshNecb !== "noash"'>{{newAshNecbNew | uppercase}}</th>
                    <th *ngIf='newAshNecb == "noash"'>Custom Baseline</th>


                </tr>
                <tr>
                    <td colspan="3">ENVELOPE PERFORMANCE </td>
                </tr>

                <tr>
                    <td>EXTERNAL WALLS U VALUE</td>

                    <td><span class="extwidth">{{ walluval }}</span><span class="extwidth">W/m2.c</span><span
                            class="extwidth">{{ wallip }}</span></td>

                    <td><span class="extwidth">{{ wallan }}</span><span class="extwidth">W/m2.c</span><span
                            *ngIf='newAshNecb !== "noash"' class="extwidth">{{ walashnec }}</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth">{{ newcustBase }}</span></td>

                </tr>

                <tr>
                    <td>ROOF U VALUE</td>

                    <td><span class="extwidth">{{roofuval }}</span><span class="extwidth">W/m2.c</span><span
                            class="extwidth">{{ roofip }}</span></td>

                    <td><span class="extwidth">{{ roofan }} </span><span class="extwidth">W/m2.c</span><span
                            *ngIf='newAshNecb !== "noash"' class="extwidth">{{ roofrvi }}</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth">{{ newcustBaseRoof }}</span></td>

                </tr>

                <tr>
                    <td>GROUND FLOOR U VALUE</td>

                    <td><span class="extwidth">{{ flooruval }}</span><span class="extwidth">W/m2.c</span><span
                            class="extwidth">{{ floorip }}</span></td>

                    <td><span class="extwidth">{{ flooran }}</span><span class="extwidth">W/m2.c</span><span
                            *ngIf='newAshNecb !== "noash"' class="extwidth">{{ flooranfvi }}</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth">{{ newcustBaseFloor }}</span></td>

                </tr>

                <tr>
                    <td>WINDOW U VALUE</td>

                    <td><span class="extwidth">{{ winuval }}</span><span class="extwidth">W/m2.c</span><span
                            class="extwidth">{{ winip }}</span></td>

                    <td><span class="extwidth">{{ winan }}</span><span class="extwidth">W/m2.c</span><span
                            *ngIf='newAshNecb !== "noash"' class="extwidth">{{ winipBase }}</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth">{{ newcustBaseWindow }}</span></td>

                </tr>

                <tr>
                    <td>WINDOW SHGC</td>

                    <td><span class="extwidth">{{winshgc }}</span><span class="extwidth_two"></span></td>

                    <td><span class="extwidth">{{ winanshgc }}</span><span class="extwidth_two"></span></td>

                </tr>

                <tr>
                    <td>WINDOW TO WALL RATIO</td>

                    <td><span class="extwidth">{{ wwronerepNew }}</span><span class="extwidth_two">As per design</span>
                    </td>

                    <td><span class="extwidth">{{ wwr }}</span><span class="extwidth_two">As per CODE</span></td>

                </tr>

                <tr>
                    <td>SHADING</td>


                    <td><span class="extwidth">{{cellfive }}</span><span class="extwidth_two">As per design</span></td>

                    <td *ngIf='newAshNecb != "noash"'>{{ shd }}</td>
                    <td *ngIf='newAshNecb == "noash"'>{{ newcustBaseShading }}</td>

                </tr>

                <tr>
                    <td>INFILTRATION</td>

                    <td><span class="extwidth">{{ inflt }}</span><span class="extwidth_two">I/s/m2(fac)</span></td>

                    <td>Same as Design</td>

                </tr>
            </table>
            <!-- BUILDING PERFORMANCE VARIABLES  END -->

            <!-- INTERNAL GAINS  START -->
            <table id="internalgain" *ngFor="let folder of lightData?.projLists | slice:0:1">
                <tr>
                    <th></th>
                    <th>{{cellOption}}</th>
                    <th *ngIf='newAshNecb !== "noash"'>{{newAshNecbNew | uppercase}}</th>
                    <th *ngIf='newAshNecb == "noash"'>Custom Baseline</th>


                </tr>
                <tr>
                    <td colspan="3">INTERNAL GAINS </td>
                </tr>

                <tr>
                    <td>LIGHTING</td>

                    <td><span class="extwidth">{{lpduval }}</span><span class="extwidth">W/m2.c</span><span
                            class="extwidth whitespace-nowrap">As per Design </span></td>

                    <td><span *ngIf='newAshNecb !== "noash"' class="extwidth">{{ litNew }}</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth">{{ lpduvalCost }}</span><span
                            class="extwidth">W/m2.c</span><span  class="extwidth whitespace-nowrap">As per
                            CODE</span></td>

                </tr>

                <tr>
                    <td>DAYLIGHT SENSORS</td>

                    <td><span class="extwidth">{{ DLnew }}</span><span class="extwidth_two">As per Design
                            Selection</span></td>

                    <td><span *ngIf='newAshNecb !== "noash"' class="extwidth">{{ dls }}</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth">{{ newcustDaylight }}</span><span
                            class="extwidth_two">As per CODE</span></td>

                </tr>

                <tr>
                    <td>PEOPLE</td>

                    <td><span class="extwidth">{{ occup }}</span><span class="extwidth_two">As per Design</span></td>

                    <td>Same as Design</td>

                </tr>

                <!--  <tr>
                   <td>EQUIPMENT</td> 
                  
                   <td><span class="extwidth">8</span><span class="extwidth">W/m2.c</span><span class="extwidth">R 60</span></td>
                   
                   <td>Same as Design</td>
     
               </tr> -->

                <tr>
                    <td>SCHEDULES</td>

                    <td>As per design</td>

                    <td>Same as Design</td>

                </tr>


            </table>



            <!-- INTERNAL GAINS  END -->

            <!-- HVAC SYSTEM  START -->


            <table id="hvcsyst">

                <tr>
                    <th></th>
                    <th>{{cellOption}}</th>
                    <th *ngIf='newAshNecb !== "noash"'>{{newAshNecbNew | uppercase}}</th>
                    <th *ngIf='newAshNecb == "noash"'>Custom Baseline</th>


                </tr>
                <!--  <tr>
                   <td colspan="3">HVAC SYSTEMS </td> 
                 </tr> -->

                <tr>
                    <td>SYSTEM</td>

                    <td>{{ cellnineNew }}</td>

                    <td *ngIf='newAshNecb != "noash"'>{{ hva }}</td>
                    <td *ngIf='newAshNecb == "noash"'>{{ newcustBaseHvac }}</td>

                </tr>

                <!--   <tr>
                     <td>HEATING SOURCE</td> 
                    
                     <td><span class="extwidth">Hot Water Boiler</span><span class="extwidth_two">As per Design selection</span></td>
               
                     <td><span class="extwidth">Hot Water Boiler</span><span class="extwidth_two">As per CODE</span></td>
       
                 </tr> -->

                <tr>
                    <td>HEATING COP</td>

                    <td><span class="extwidth">{{ boilercop }}</span><span class="extwidth_two">As per Design
                            selection</span></td>

                    <td><span *ngIf='newAshNecb == "noash"' class="extwidth">{{ boilercopanCust }}</span><span
                            *ngIf='newAshNecb != "noash"' class="extwidth">{{ boilercopan }}</span><span
                            class="extwidth_two">As per CODE</span></td>

                </tr>

                <!--  <tr>
                     <td>COOLING SOURCE</td> 
                    
                     <td><span class="extwidth">Electric Water Cooled Chiller</span><span class="extwidth_two">As per Design selection</span></td>
               
                     <td><span class="extwidth">Electric Water Cooled Chiller</span><span class="extwidth_two">As per CODE</span></td>
       
                 </tr> -->

                <tr>
                    <td>COOLING COP</td>

                    <td><span class="extwidth">{{ chillercop }}</span><span class="extwidth_two">As per Design
                            selection</span></td>

                    <td><span *ngIf='newAshNecb == "noash"' class="extwidth">{{ chillercopanCust }}</span><span
                            *ngIf='newAshNecb != "noash"' class="extwidth">{{ chillercopan }}</span><span
                            class="extwidth_two">As per CODE</span></td>

                </tr>

                <tr>
                    <td>FRESH AIR</td>

                    <td><span class="extwidth">{{ frrepval }}</span><span class="extwidth">I/s</span>
                        <span class="extwidth whitespace-nowrap">{{ frrep }}</span></td>

                    <td>Same as Design</td>

                </tr>

                <tr>
                    <td>HEAT RECOVERY</td>

                    <td><span class="extwidth">{{ celltenNewHeat }}</span><span class="extwidth_two">As per Design
                            selection</span></td>

                    <td><span *ngIf='newAshNecb == "noash"' class="extwidth">{{ newcustHtRec }}</span><span
                            *ngIf='newAshNecb != "noash"' class="extwidth">{{ hre }}</span><span class="extwidth_two">As
                            per CODE</span></td>

                </tr>

                <tr>
                    <td>HEAT RECOVERY EFFECTIVENESS</td>

                    <td><span class="extwidth_four">Heating</span><span *ngIf='celltenNewHeat == "Y"'
                            class="extwidth_four">{{ optheat }} %</span><span *ngIf='celltenNewHeat == "N"'
                            class="extwidth_four">0%</span><span class="extwidth_four">Cooling</span><span
                            *ngIf='celltenNewHeat == "Y"' class="extwidth_four">{{ optcool }} %</span><span
                            *ngIf='celltenNewHeat == "N"' class="extwidth_four">0%</span></td>

                    <td><span class="extwidth_four">Heating</span><span *ngIf='newAshNecb != "noash"'
                            class="extwidth_four">{{ baselinheat }} %</span><span *ngIf='newAshNecb == "noash"'
                            class="extwidth_four">{{ custheat}} %</span><span class="extwidth_four">Cooling</span><span
                            *ngIf='newAshNecb != "noash"' class="extwidth_four">{{ baselincool }} %</span><span
                            *ngIf='newAshNecb == "noash"' class="extwidth_four">{{ custcool }} %</span></td>

                </tr>
            </table>



            <!-- HVAC SYSTEM  END -->





        </div>

        <!-- <div class="row"> -->

        <!-- <div class="col-md-6"> -->
        <!-- <app-sankeyreport></app-sankeyreport>  -->



        <!-- </div> -->




        <!-- </div> -->


    </div>
    <!-- hidetwo div end -->


    <div id="hidebefor">
        <div class="chartButtons">


        <div id="charttwo"> 

             <button id="btnon" (click)="charttwofun()">Comparison chart with baseline</button>
            <button id="btntw" (click)="chartonefun()">Selection option Graphs</button> 

            <div id="option">{{cellOption}} is Selected</div> 


         </div>
         
        <div id="threebtn">
            <button id="backwiz" (click)="backClicked()" class="backMfrd mr-2" mat-raised-button color="primary">Wizard
                Variables</button>

            <button id="dwdpdf" (click)="downloadPdf()" type="button"
                mat-raised-button class="mr-2" color="primary">Download
                Report</button>
            <button id="actcost" (click)="activateCost()" type="button" mat-raised-button color="primary">Activate
                KPIs</button>
        </div>
    </div>

        <div id="allcharts" class="mt-4">
            <!-- <div id="upval">
   <h3>Below graph values are not updated on chart selection, please click on grid options to get
 updated values on graph</h3>
 </div> -->



            <div class="row">
                <div class="col-md-12 d-flex">
                    <!-- <h4 class="col-md-3 text-center selectionOptionComparison">Selection Option Graphs</h4>  -->
                    <div id="charttwo" class="col-md-3 text-center">

                      <!--   <button id="btnon" (click)="charttwofun()">Comparison chart with baseline</button>
                        <button id="btntw" (click)="chartonefun()">Selection option Graphs</button> 
            
                        <div id="option" class="text-center">{{cellOption}} is Selected</div>-->
            
            
                    </div>
                  <!--  <h4 class="col-md-4 selectionOptionComparison">Comparison Chart With Baseline</h4> -->
                </div>
               <!--   <div class="col-md-5 border-right-2-grey">
                    
                   
                    <app-googlesnakey></app-googlesnakey>


                  <div id="materialdatatable">

                        <app-material-table></app-material-table>
                        <div id="chartneg"></div>
                       <table class="table table-bordered table-sm mt-4 width-98">
                                <tbody>
                                    <tr id="chartTabComp">
                                        <td class="text-center "></td>
                                        <td class="text-center">HEATING</td>
                                        <td class="text-center">COOLING</td>
                                        <td class="text-center">FANS</td>
                                        <td class="text-center">PUMPS</td>
                                        <td class="text-center">HEAT REJ</td>
										<td class="text-center">HUMIDIFICATION</td>
                                        <td class="text-center">LIGHTING</td>
                                        <td class="text-center">EQP</td>
                                        <td class="text-center">DHW</td>
                                        <td class="text-center">SOLAR PV</td>
                                        <td class="text-center">WIND</td>
                                       
                                    </tr>
                                    <tr id="chartTabValComp">
                                        <td class="text-center">{{cellOption}}</td>
                                        <td class="text-center" id="htengComp">{{HeatingEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="coolengComp">
                                            {{CoolingEnergyData | number: '1.0-0'}}</td>
                                        <td class="text-center" id="fanengComp">{{FansEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="pumpengComp">{{PumpsEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="heatengComp">
                                            {{HeatRejEnergyData | number: '1.0-0'}}</td>
										<td class="text-center" id="humComp">
                                            {{HumData | number: '1.0-0'}}</td>
                                        <td class="text-center" id="lightengComp">
                                            {{LightingEnergyData | number: '1.0-0'}}</td>
                                        <td class="text-center" id="eqengComp">{{equipEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="dhwengComp">{{DHWEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="slrengComp">{{solarEnergyData | number: '1.0-0'}}  
										<td class="text-center" id="slrengComp">{{windEnergyData | number: '1.0-0'}}
                                        </td>
                                       
                                    </tr>
                                    <tr id="chartTabValCompAn">
                                        <td class="text-center" *ngIf='newAshNecb !== "noash"'>{{newAshNecb | uppercase}}</td>
                                        <td class="text-center" *ngIf='newAshNecb == "noash"'>Custom Baseline</td>
                                        <td class="text-center" id="htengCompAn">{{Heating| number: '1.0-0' }}</td>
                                        <td class="text-center" id="coolengCompAn">{{Cooling| number: '1.0-0' }}</td>
                                        <td class="text-center" id="fanengCompvAn">{{Fans| number: '1.0-0'}}</td>
                                        <td class="text-center" id="pumpengCompAn">{{Pumps| number: '1.0-0'}}</td>
                                        <td class="text-center" id="heatengCompAn">{{HeatRej| number: '1.0-0'}}</td>
										<td class="text-center" id="humCompAn">{{Hum| number: '1.0-0'}}</td>
                                        <td class="text-center" id="lightengCompAn">{{Lighting| number: '1.0-0'}}</td>
                                        <td class="text-center" id="eqengCompAn">{{equipBaseline| number: '1.0-0'}}</td>
                                        <td class="text-center" id="dhwengCompAn">{{DHW| number: '1.0-0'}}</td>
                                        <td class="text-center" *ngIf='newAshNecb !== "noash"' id="slrengCompAn">0</td>
                                        <td class="text-center" *ngIf='newAshNecb == "noash"' id="slrengCompAn">{{SolarBaseline| number: '1.0-0'}}</td>
										<td class="text-center" *ngIf='newAshNecb !== "noash"' id="slrengCompAn">0</td>
                                        <td class="text-center" *ngIf='newAshNecb == "noash"' id="slrengCompAn">{{WindBaseline| number: '1.0-0'}}</td>

                                    </tr>
                                </tbody>
                            </table>
                        <!-- <div id="chartTab">
                        <div style="width:52px">Energy</div>
                        <div>Heating</div>
                        <div>Cooling</div>
                        <div>Fans</div>
                        <div>Pumps</div>
                        <div>HeatRej</div>
                        <div>Lighting</div>
                        <div>Equipment</div>
                        <div>Dhw</div>
                        <div>Solar</div>
                        <div>Wind</div>
                    </div> -->

                        <!-- <div id="chartTabVal">
                        <div style="width:52px">MWh</div>
                        <div id="hteng"></div>
                        <div id="cooleng"></div>
                        <div id="faneng"></div>
                        <div id="pumpeng"></div>
                        <div id="heateng"></div>
                        <div id="lighteng"></div>
                        <div id="eqeng"></div>
                        <div id="dhweng"></div>
                        <div id="slreng"></div>
                        <div id="wideng"></div>
                    </div> 

                        <div id="total">Total Energy : <span id="totalVal"></span> MWh </div> 


                    </div>


                </div>-->
                <div class="col-md-3">
                    
                  <!--  <div id="stack_chart_outer" class="d-none">
                        <div id="stack_chart" class="mychart"></div>
                        <div>
                            
                            <!-- <div id="chartTabComp">
                    <div>Energy</div>
                    <div>Heating</div>
                    <div>Cooling</div>
                    <div>Fans</div>
                    <div>Pumps</div>
                    <div>HeatRej</div>
                    <div>Light</div>
                    <div>Equi.</div>
                    <div>Dhw</div>
                    <div>Renew.</div>
                    <div>Total<span class="mhw">(MWh)</span></div>
                </div> -->

                            <!-- <div id="chartTabValComp">
                    <div>{{cellOption}}</div>
                    <div id="htengComp">{{HeatingEnergyData}}</div>
                    <div id="coolengComp">{{CoolingEnergyData}}</div>
                    <div id="fanengComp">{{FansEnergyData}}</div>
                    <div id="pumpengComp">{{PumpsEnergyData}}</div>
                    <div id="heatengComp">{{HeatRejEnergyData}}</div>
                    <div id="lightengComp">{{LightingEnergyData}}</div>
                    <div id="eqengComp">{{equipEnergyData}}</div>
                    <div id="dhwengComp">{{DHWEnergyData}}</div>
                    <div id="slrengComp">{{RenewEnergyData}}</div>
                    <div id="widengComp">{{ optionTotal | number:'1.1-2' }}</div>


                </div> -->
<!-- 
                            <div id="chartTabValCompAn">
                                <div *ngIf='newAshNecb !== "noash"'>{{newAshNecb | uppercase}}</div>
                                <div *ngIf='newAshNecb == "noash"'>Custom Baseline</div>
                                <div id="htengCompAn">{{Heating }}</div>
                                <div id="coolengCompAn">{{Cooling }}</div>
                                <div id="fanengCompvAn">{{Fans}}</div>
                                <div id="pumpengCompAn">{{Pumps}}</div>
                                <div id="heatengCompAn">{{HeatRej}}</div>
                                <div id="lightengCompAn">{{Lighting}}</div>
                                <div id="eqengCompAn">{{equipBaseline}}</div>
                                <div id="dhwengCompAn">{{DHW}}</div>
                                <div *ngIf='newAshNecb !== "noash"' id="slrengCompAn">0</div>
                                <div *ngIf='newAshNecb == "noash"' id="slrengCompAn">{{RenewBaseline}}</div>
                                <div *ngIf='newAshNecb !== "noash"' id="widengCompAn">{{baselineTotal | number:'1.1-2'
                                    }}</div>
                                <div *ngIf='newAshNecb == "noash"' id="widengCompAn">{{baselineTotal + RenewBaseline |
                                    number:'1.1-2' }}</div>
                            </div> 
                        </div>
                    </div>-->
					
                    <div id="groupout" class="d-none">
                        <div id="group_chart" class="mychart group-chart-class"></div>
                        <div id="heatLoadTab">
                            <div></div>
                            <div>PEAK HEATING LOAD (kW)</div>
                            <div>PEAK COOLING LOAD (TR)</div>

                        </div>

                        <div id="heatLoadTabone">


                            <div>{{cellOption}}</div>
                            <div>{{heatLoadDesign}}</div>
                            <div>{{coolLoadDesign}}</div>



                        </div>

                        <div id="heatLoadTabtwo">


                            <div *ngIf='newAshNecb !== "noash"'>{{newAshNecb | uppercase}}</div>
                            <div *ngIf='newAshNecb == "noash"'>Custom Baseline</div>
                            <div>{{heatLoadBaseline}}</div>
                            <div>{{coolLoadBaseline}}</div>



                        </div>



                    </div>
                    <div id="diff_chart" class="mychart diff_chart-class"></div>


                </div>
				  <div class="col-md-3">
				<!--  <div id="donutchart"></div> -->
				  </div>
            </div>

            <div id="chartone">
					<div id="chartneg_outer">
					<div id="chartneg"></div>
                       <table class="table table-bordered table-sm mt-4 materialdatatable-class width-98">
                                <tbody>
                                    <tr id="chartTabComp">
                                        <td class="text-center ">Energy (MWh)</td>
                                        <td class="text-center">Heating</td>
                                        <td class="text-center">Cooling</td>
                                        <td class="text-center">Fans</td>
                                        <td class="text-center">Pumps</td>
                                        <td class="text-center">Heat Rej</td>
										<td class="text-center">Hum/Pro</td>
                                        <td class="text-center">DHW</td>
                                        <td class="text-center">Lighting</td>
                                        <td class="text-center">Equipment</td>
                                        
                                        <td class="text-center">Renewables</td>
                                       
                                    </tr>
                                    <tr id="chartTabValComp">
                                        <td class="text-center">{{cellOption}}</td>
                                        <td class="text-center" id="htengComp">{{HeatingEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="coolengComp">
                                            {{CoolingEnergyData | number: '1.0-0'}}</td>
                                        <td class="text-center" id="fanengComp">{{FansEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="pumpengComp">{{PumpsEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="heatengComp">
                                            {{HeatRejEnergyData | number: '1.0-0'}}</td>
										<td class="text-center" id="humComp">
                                            {{HumData | number: '1.0-0'}}</td>
                                        <td class="text-center" id="dhwengComp">{{DHWEnergyData | number: '1.0-0'}}
                                        </td>
                                        <td class="text-center" id="lightengComp">
                                            {{LightingEnergyData | number: '1.0-0'}}</td>
                                        <td class="text-center" id="eqengComp">{{equipEnergyData | number: '1.0-0'}}
                                        </td>
                                        
                                        <td class="text-center" id="slrengComp">{{RenewEnergyData | number: '1.0-0'}}  
										</td>
                                       
                                    </tr>
                                    <tr id="chartTabValCompAn">
                                       <!-- <td class="text-center" *ngIf='newAshNecb !== "noash"'>{{newAshNecb | uppercase}}</td>-->
									    <td class="text-center" *ngIf='newAshNecb !== "noash"'>{{(newAshNecb==='Ashare'? ashrae:necb) | uppercase}}</td>
                                        <td class="text-center" *ngIf='newAshNecb == "noash"'>{{cb}}</td>
                                        <td class="text-center" id="htengCompAn">{{Heating| number: '1.0-0' }}</td>
                                        <td class="text-center" id="coolengCompAn">{{Cooling| number: '1.0-0' }}</td>
                                        <td class="text-center" id="fanengCompvAn">{{Fans| number: '1.0-0'}}</td>
                                        <td class="text-center" id="pumpengCompAn">{{Pumps| number: '1.0-0'}}</td>
                                        <td class="text-center" id="heatengCompAn">{{HeatRej| number: '1.0-0'}}</td>
										<td class="text-center" id="humCompAn">{{Hum| number: '1.0-0'}}</td>
                                        <td class="text-center" id="dhwengCompAn">{{DHW| number: '1.0-0'}}</td>
                                        <td class="text-center" id="lightengCompAn">{{Lighting| number: '1.0-0'}}</td>
                                        <td class="text-center" id="eqengCompAn">{{equipBaseline| number: '1.0-0'}}</td>
                                        
                                        <td class="text-center" *ngIf='newAshNecb !== "noash"' id="slrengCompAn">0</td>
                                        <td class="text-center" *ngIf='newAshNecb == "noash"' id="slrengCompAn">{{RenewBaseline| number: '1.0-0'}}</td>

                                    </tr>
                                </tbody>
                            </table>
						</div>
                <div id="stack_chart_outer" >
                    <div id="stack_chart" class="mychart"></div>
                    <table class="table table-bordered table-sm mt-4 materialdatatable-class width-55">
                        <tbody>
                            <tr id="energyComp">
                                <td class="text-center "></td>
                                <td class="text-center">{{cellOption}}</td>
                                <td class="text-center" *ngIf='newAshNecb !== "noash"'>{{(newAshNecb==='Ashare'? ashrae:necb) | uppercase}}</td>
                                <td class="text-center" *ngIf='newAshNecb == "noash"'>{{cb}}</td>
                               
                            </tr>
                            <tr id="energyValComp">
                                <td class="text-center">Energy (MWh)</td>
                                <td class="text-center" id="htengComp">{{ optionTotal | number:'1.1-2' }}
                                </td>
                                <td *ngIf='newAshNecb !== "noash"'>{{baselineTotal | number:'1.1-2' }}</td>
                                <td *ngIf='newAshNecb == "noash"'>{{baselineTotal + RenewBaseline | number:'1.1-2' }}</td>
                            </tr>                           
                        </tbody>
                    </table>
                </div>
                
                <div id="groupout" style="display: none;">
                    <div id="group_chart" class="mychart" style="width:500px;height:300px"></div>
                    <div id="heatLoadTab">
                        <div></div>
                        <div>PEAK HEATING LOAD (kW)</div>
                        <div>PEAK COOLING LOAD (TR)</div>

                    </div>

                    <div id="heatLoadTabone">


                        <div>{{cellOption}}</div>
                        <div>{{heatLoadDesign}}</div>
                        <div>{{coolLoadDesign}}</div>



                    </div>

                    <div id="heatLoadTabtwo">


                        <div *ngIf='newAshNecb !== "noash"'>{{newAshNecb | uppercase}}</div>
                        <div *ngIf='newAshNecb == "noash"'>Custom Baseline</div>
                        <div>{{heatLoadBaseline}}</div>
                        <div>{{coolLoadBaseline}}</div>



                    </div>



                </div>
                <div id="diff_chart" class="mychart" style="width:800px;height:400px"></div>




            </div>

            <div id="hel">
               
                <app-googlesnakey></app-googlesnakey>


              <!--  <div id="materialdatatable">

                    <app-material-table></app-material-table>
                    <div id="chartneg"></div>
                    <div id="chartTab">
                        <div style="width:52px">Energy</div>
                        <div>Heating</div>
                        <div>Cooling</div>
                        <div>Fans</div>
                        <div>Pumps</div>
                        <div>HeatRej</div>
                        <div>Lighting</div>
                        <div>Equipment</div>
                        <div>Dhw</div>
                        <div>Solar</div>
                        <div>Wind</div>
                    </div>

                    <div id="chartTabVal">
                        <div style="width:52px">MWh</div>
                        <div id="hteng"></div>
                        <div id="cooleng"></div>
                        <div id="faneng"></div>
                        <div id="pumpeng"></div>
                        <div id="heateng"></div>
                        <div id="lighteng"></div>
                        <div id="eqeng"></div>
                        <div id="dhweng"></div>
                        <div id="slreng"></div>
                        <div id="wideng"></div>
                    </div>

                    <div id="total">Total Energy : <span id="totalVal"></span> MWh </div>


                </div>-->

				<div id="donutchart"></div>

            </div> 



            <!--  <div id="threebtn">
     <button id="backwiz" (click)="backClicked()" class="backMfrd" mat-raised-button color="primary">Wizard Variables</button>
     
     <button id="dwdpdf" (click) = "downloadPdf()"  type="button" mat-raised-button color="primary">Download Report</button>
     <button id="actcost" (click) = "activateCost()"  type="button" mat-raised-button color="primary">Activate Cost Analysis</button>
   </div> -->


        </div> <!-- all charts div end  -->




        <div id="myDiv"><!-- Plotly chart will be drawn inside this DIV --></div>




    </div> <!-- end hidebfor -->


</div><!-- expm -->


<button id="scrbuttons" (click)="scrLeft()">&#62;&#62;</button>
<button id="scrbuttonsrt" (click)="scrRight()">&#60;&#60;</button>